export const CHANGE_URL = 'changeURL'
export const CHECK_AUTH = 'checkAuth'
export const FETCH_QRCODE_LIST = 'fetchQrcode'